import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  CardBody,
  Center,
  Image,
  Flex,
  Text,
  Heading,
  VStack,
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  useColorModeValue,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useToast,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { ColorModeSwitcher } from "../../ColorModeSwitcher";
import { Nav } from "../../containers/Nav";
import { Footer } from "../../containers/Footer";
import { getAllMovieRatings } from "../../actions/ratings";
import AdminNav from "../../components/adminNav";
import { validateAdminAuth, formatDate, truncateLongText } from "../../helpers";

function AdminRatings() {
  const toast = useToast();
  const navigate = useNavigate();
  const [fetching, setFetching] = useState(false);
  const [movieRatings, setMovieRatings] = useState("");

  const lightGray = useColorModeValue("gray.100", "gray.900");

  const userInfo = validateAdminAuth();
  if (userInfo?.organization) {
    navigate("/brandCampaigns");
  } else if (!userInfo) {
    navigate("/login");
  }

  useEffect(() => {
    setFetching(true);

    getAllMovieRatings().then((ratings) => {
      const ratingSumByMovieId = ratings.reduce(
        (accumulator, current) => {
          if(!current.movieTitle){
            return accumulator
          }
          const movieId = current.movieId;
          const isRatingTrue = current.rating === true;

          // Initialize counters if not present
          accumulator[movieId] = accumulator[movieId] || {
            likeCount: 0,
            dislikeCount: 0,
          };
          accumulator[movieId]["title"] = current.movieTitle || "";

          // Increment the count based on the rating value
          if (isRatingTrue) {
            accumulator[movieId].likeCount++;
          } else {
            accumulator[movieId].dislikeCount++;
          }

          return accumulator;
        },
        {}
      );
      console.log(ratingSumByMovieId)
      setMovieRatings(ratingSumByMovieId);

      setFetching(false);
    }).catch(err => {
      toast({
        title: `There was an issue getting ratings`,
        status: "error",
        duration: 4000,
        isClosable: true,
      });

    })
  }, []);

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      color="blackAlpha.700"
      pb="75px"
    >
      <Nav />

      <GridItem pl="2" area={"main"}>
        <Center>
          <VStack>
            <AdminNav />

            {!fetching && movieRatings.length !== 0 && (
              <Card maxWidth="1200px" mx="5" my="5" p="3" bg={lightGray}>
                <Flex m="2">
                  <Box width="100%">
                    <Heading fontSize="2xl">All Ratings</Heading>
                  </Box>
                </Flex>
                <TableContainer>
                  <Table variant="striped">
                    <Thead>
                      <Tr>
                        <Th>Title</Th>
                        <Th>Likes</Th>
                        <Th>Dislikes</Th>
                      </Tr>
                    </Thead>
                    <Tbody fontSize="sm">
                      {Object.keys(movieRatings).map((movieId) => {
                        return (
                          <Tr>
                            <Td>{movieRatings[movieId].title}</Td>
                            <Td>{movieRatings[movieId].likeCount}</Td>
                            <Td>{movieRatings[movieId].dislikeCount}</Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Card>
            )}
          </VStack>
        </Center>
      </GridItem>

      <Footer />
    </Grid>
  );
}

export default AdminRatings;
